import { TweenMax, Power3 } from 'gsap/all';
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/all'
gsap.registerPlugin(ScrollToPlugin)

export default class WooTabsScroll {
  
  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }
  
  setVars() {
    this.tabs = document.querySelectorAll('.tabs__item');
    return this.tabs;
  }
  
  setEvents() {
    this.tabs.forEach(item => {
      item.addEventListener('click', (e) => {
        setTimeout(() => {
          const rect = this.getPosition(e.target);
          TweenMax.to(window, 1, { scrollTo: {y: rect.y - 90}, ease: Power3.easeInOut })
        }, 500);
      })
    })
  }
  
  getPosition(element) {
    let xPosition = 0;
    let yPosition = 0;
    
    while(element) {
      xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
      yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }
    
    return { x: xPosition, y: yPosition };
  }
}